var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4 19.3391V4.6609C4 3.90733 4.80189 3.42453 5.46789 3.77712L19.3306 11.1162C20.0401 11.4918 20.0401 12.5082 19.3306 12.8838L5.46789 20.2229C4.80189 20.5755 4 20.0927 4 19.3391Z","fill":"currentColor"}));
}

Play.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Play;

Play.default = Play;
